<template>
	<MappingInterfaceFieldHeader
		:title="`Map a ${serviceName} connection block from ${configurationType} setup`"
		:allowChange="credentialSelectorFields?.length > 0"
		@change-mapping="openChangeConnectionMappingDialog"
	/>
</template>

<script>
import { mapGetters } from 'vuex';
import { editNode } from '@/store/modules/selectedNode/getters';
import { getService } from '@/store/modules/apps/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import MappingInterfaceFieldHeader from '@/components/common/ProfileSelector/MappingInterfaceFieldHeader.vue';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';
import { userSpecificConfigurationId, generalConfigurationId } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
export default {
	name: 'ConnectionMappingTitle',
	components: { MappingInterfaceFieldHeader },
	props: {
		serviceId: { type: Number },
		credentialsData: { type: Object },
		configurationType: { type: String },
		overrideSelectProfile: { type: Function },
		credentialSelectorFields: { type: Array },
	},
	computed: {
		...mapGetters([getService.fullPath, editNode.fullPath, userSpecificConfigurationId.fullPath, generalConfigurationId.fullPath]),
		selectedApp() {
			return this[getService.fullPath](this.serviceId) || {};
		},
		serviceName() {
			return this.selectedApp.service_name;
		},
		nodeCredentialsData() {
			return this[editNode.fullPath].credentials_configuration;
		},
		relevantCredentialsData() {
			return this.credentialsData || this.nodeCredentialsData;
		},
		configurationId() {
			return this.relevantCredentialsData.credentials_type === CredentialsTypes.ProfileBased
				? this[userSpecificConfigurationId.fullPath]
				: this[generalConfigurationId.fullPath]; // CredentialsTypes.AccountBased
		},
	},
	methods: {
		async openChangeConnectionMappingDialog() {
			await AppDialogManagerService.openChangeConnectionMappingDialog({
				overrideSelectProfile: this.overrideSelectProfile,
				credentialSelectorFields: this.credentialSelectorFields,
				sourceFieldUuid: this.relevantCredentialsData.source_field_uuid,
				configurationId: this.configurationId,
				serviceName: this.serviceName,
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
